export default __webpack_public_path__ + "static/media/slide1.4f23def8.png";